<template>
  <slide-over-right :id="sorId" editType="pass" v-on:showModal="showModal">
    <loading :active.sync="isLoading"></loading>

    <div class="flex flex-wrap px-6 pt-12 w-full">
      <div class="items-center w-1/2 panel-title header-title">
        {{ titleText }}
      </div>
    </div>

    <div class="px-6 mt-2">
      <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
        <form
          @submit.prevent="handleSubmit(confirmSubmit)"
          enctype="multipart/form-data"
          class="sm:pb-24 2xl:px-6 2xl:pb-3 sm:px-1"
        >
          <div class="flex items-center pt-8">
            <!-- start: name & phone -->
            <div class="w-1/2">
              <AppInput
                type="richselect"
                :name="
                  $t(
                    'components.subscriptionManagement.addEdit.steps.subscription.title.subscriptionValueType'
                  )
                "
                :label="
                  $t(
                    'components.subscriptionManagement.addEdit.steps.subscription.title.subscriptionValueType'
                  )
                "
                :placeholder="
                  $t(
                    'components.subscriptionManagement.addEdit.steps.subscription.placeHolder.subscriptionValueType'
                  )
                "
                :infoDescription="
                  $t(
                    'components.subscriptionManagement.addEdit.steps.subscription.infoDescription.subscriptionValueType'
                  )
                "
                :options="passCategoryChoices"
                hide-search-box
                rules="required"
                v-model="form.category"
              />
            </div>
            <div class="pl-2 w-1/2">
              <AppInput
                type="richselect"
                :name="
                  $t(
                    'components.subscriptionManagement.addEdit.steps.subscription.title.subscriptionType'
                  )
                "
                :label="
                  $t(
                    'components.subscriptionManagement.addEdit.steps.subscription.title.subscriptionType'
                  )
                "
                :placeholder="
                  $t(
                    'components.subscriptionManagement.addEdit.steps.subscription.placeHolder.subscriptionType'
                  )
                "
                :options="passTypes"
                hide-search-box
                rules="required"
                v-model="form.period"
              />
            </div>
          </div>

          <div>
            <AppInput
              type="richselect"
              :name="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.assignedFleet'
                )
              "
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.assignedFleet'
                )
              "
              :placeholder="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.placeHolder.assignedFleet'
                )
              "
              :options="getFleetOptions"
              hide-search-box
              rules="required"
              v-model="form.assigned_fleet"
            />
          </div>

          <div>
            <AppInput
              type="text"
              rules="required"
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.title'
                )
              "
              placeholder="e.g. Daily Pass"
              maxlength="28"
              v-model="form.title"
              :infoDescription="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.infoDescription.title'
                )
              "
            />
          </div>

          <div>
            <AppInput
              type="richselect"
              :name="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.vehicleType'
                )
              "
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.vehicleType'
                )
              "
              :placeholder="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.placeHolder.vehicleType'
                )
              "
              :options="vehicleTypes"
              hide-search-box
              rules="required"
              v-model="form.vehicle_type"
            />
          </div>

          <div v-if="form.category === 1">
            <AppInput
              type="number"
              rules="required"
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.ridingTime'
                )
              "
              :infoDescription="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.infoDescription.ridingTime'
                )
              "
              placeholder="e.g. 60"
              v-model="form.free_riding_time_minutes"
              :haveUnitText="true"
              unitText="Min"
            />
          </div>

          <div>
            <AppInput
              type="number"
              step="0.01"
              rules="required|between:0,100000"
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.subscriptionPrice'
                )
              "
              placeholder="e.g. 49.99"
              v-model="form.price"
              :haveUnitText="true"
              :unitText="currencySymbol"
            />
          </div>

          <div class="mt-2">
            <AppInput
              type="richselect"
              :name="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.status'
                )
              "
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.status'
                )
              "
              :placeholder="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.placeHolder.status'
                )
              "
              :options="statusOptions"
              hide-search-box
              rules="required"
              v-model="is_active"
            />
          </div>

          <div v-if="form.category === 0" class="mt-2">
            <TCheckbox
              v-model="show_unlock_charge"
              :name="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.discountUnlockChargeAllowed'
                )
              "
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.discountUnlockChargeAllowed'
                )
              "
              wrapped
            />
            <p class="text-xs text-gray-500">
              {{
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.infoDescription.discountUnlockChargeAllowed'
                )
              }}
            </p>
          </div>

          <div
            v-if="form.category === 0 && show_unlock_charge"
            class="flex items-center pt-4"
          >
            <AppInput
              type="number"
              step="0.01"
              rules="required|between:0,100"
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.discountUnlockCharge'
                )
              "
              placeholder="e.g. 3"
              v-model="form.unlock_charge"
              :haveUnitText="true"
              unitText="%"
            />
          </div>

          <div v-if="form.category === 0" class="mt-2">
            <TCheckbox
              v-model="show_reservation_charge"
              :name="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.discountReservationChargeAllowed'
                )
              "
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.discountReservationChargeAllowed'
                )
              "
              wrapped
            />
            <p class="text-xs text-gray-500">
              {{
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.infoDescription.discountReservationChargeAllowed'
                )
              }}
            </p>
          </div>

          <div
            v-if="form.category === 0 && show_reservation_charge"
            class="flex items-center pt-4"
          >
            <AppInput
              type="number"
              step="0.01"
              rules="required|between:0,100"
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.discountReservationCharge'
                )
              "
              placeholder="e.g. 3"
              v-model="form.reservation_charge"
              :haveUnitText="true"
              unitText="%"
            />
          </div>

          <div v-if="form.category === 0" class="mt-2">
            <TCheckbox
              v-model="show_per_minute_charge"
              :name="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.discountPerMinutesChargeAllowed'
                )
              "
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.discountPerMinutesChargeAllowed'
                )
              "
              wrapped
            />
            <p class="text-xs text-gray-500">
              {{
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.infoDescription.discountPerMinutesChargeAllowed'
                )
              }}
            </p>
          </div>

          <div
            v-if="form.category === 0 && show_per_minute_charge"
            class="flex items-center pt-4"
          >
            <AppInput
              type="number"
              step="0.01"
              rules="required|between:0,100"
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.discountPerMinuteCharge'
                )
              "
              placeholder="e.g. 15"
              v-model="form.per_minute_charge"
              :haveUnitText="true"
              unitText="%"
            />
          </div>
          <div v-if="form.category === 0" class="mt-2">
            <TCheckbox
              v-model="show_pause_per_unit_charge"
              :name="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.discountPausePerUnitChargeAllowed'
                )
              "
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.discountPausePerUnitChargeAllowed'
                )
              "
              wrapped
            />
            <p class="text-xs text-gray-500">
              {{
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.infoDescription.discountPausePerUnitChargeAllowed'
                )
              }}
            </p>
          </div>

          <div
            v-if="form.category === 0 && show_pause_per_unit_charge"
            class="flex items-center pt-4"
          >
            <AppInput
              type="number"
              step="0.01"
              rules="required|between:0,100"
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.discountPausePerUnitCharge'
                )
              "
              placeholder="e.g. 15"
              v-model="form.pause_per_unit_charge"
              :haveUnitText="true"
              unitText="%"
            />
          </div>
          <div class="mt-2">
            <TCheckbox
              v-model="form.is_minimum_fee_waived"
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.disableMinimumFeeForRide'
                )
              "
              :name="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.disableMinimumFeeForRide'
                )
              "
              wrapped
            />
            <p class="text-xs text-gray-500">
              {{
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.infoDescription.disableMinimumFeeForRide'
                )
              }}
            </p>
          </div>

          <div v-if="form.category === 0" class="mt-2">
            <TCheckbox
              v-model="show_free_minutes_each_ride"
              :name="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.freeTimeAllowed'
                )
              "
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.freeTimeAllowed'
                )
              "
              wrapped
            />
            <p class="text-xs text-gray-500">
              {{
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.infoDescription.freeTimeAllowed'
                )
              }}
            </p>
          </div>
          <div
            v-if="form.category === 0 && show_free_minutes_each_ride"
            class="flex items-center pt-4"
          >
            <AppInput
              type="number"
              rules="required|between:0,100000"
              :label="
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.freeTimeEachRide'
                )
              "
              placeholder="e.g. 30"
              v-model="form.free_minutes_each_ride"
              :haveUnitText="true"
              unitText="Min"
            />
          </div>

          <div class="flex items-center pt-6">
            <div class="pr-2 w-1/2">
              <AppInput
                type="date"
                rules="required"
                :label="
                  $t(
                    'components.subscriptionManagement.addEdit.steps.subscription.title.subscriptionStartDate'
                  )
                "
                v-model="start_date"
                v-on:input="onChangeStartDate"
              />
            </div>
            <div class="pl-2 w-1/2">
              <AppInput
                type="date"
                rules="required"
                :label="
                  $t(
                    'components.subscriptionManagement.addEdit.steps.subscription.title.subscriptionExpireDate'
                  )
                "
                v-model="end_date"
                v-on:input="onChangeExpireDate"
              />
            </div>
          </div>

          <div class="flex items-center my-5 text-sm font-bold text-gray-500">
            <span>
              {{
                $t(
                  'components.subscriptionManagement.addEdit.steps.subscription.title.descriptions'
                )
              }}</span
            >
            <div
              class="col-span-1 ml-2 cursor-pointer focus:text-gray-400"
              @click="onAddDescription"
            >
              <i class="fas fa-plus-circle" style="color: black"></i>
            </div>
          </div>
          <div
            class="flex items-center my-2"
            v-for="(item, index) in form.facility_texts"
            :key="index"
          >
            <div class="flex gap-2 items-center w-11/12 ">
              <input
                type="text"
                class="block w-full px-4 py-1.5 leading-normal bg-white border border-gray-400 rounded outline-none focus:ring-0 focus:border-gray-700 focus:placeholder-gray-500"
                v-model="item.description"
              />
            </div>

            <div class="flex justify-center w-1/12 item-center">
              <div
                class="col-span-1 cursor-pointer focus:text-gray-400"
                @click="onRemoveDescription(index)"
              >
                <i class="fas fa-minus-circle" style="color: #d90a20"></i>
              </div>
            </div>
          </div>
          <button type="submit" ref="submitButton" class="hidden">Save</button>
        </form>
      </ValidationObserver>
      <div class="flex justify-end items-center pr-2 mt-6">
        <slide-over-right-trigger :id="sorId">
          <anchor-button variant="secondary">{{
            $t('components.stepNavigation.cancel')
          }}</anchor-button>
        </slide-over-right-trigger>
        <t-button type="submit" @click="submit()" class="ml-3">{{
          actionButtonText
        }}</t-button>
      </div>
    </div>
  </slide-over-right>
</template>

<script>
import { PassConfig } from '@/config/PassConfig'
import { EventBus } from '@/utils/EventBus'
import SlideOverRight from '@/components/modals/SlideOverRight'
import AnchorButton from '@/components/form/AnchorButton'
import SlideOverRightTrigger from '@/components/modals/SlideOverRightTrigger'
import xMan from '@/utils/xMan'
import { getDate } from '@/utils'
import { convertToTitleCase } from '@/components/picker/date-range/utils/CollectionUtils'
import { vehicleTypesForOrg } from '@/utils'
import { getAllFleetsData } from '@/services/cache'
export default {
  name: 'AddPass',
  components: {
    SlideOverRight,
    AnchorButton,
    SlideOverRightTrigger,
  },
  data() {
    return {
      sorId: PassConfig.events.sorId,
      isLoading: false,
      form: {},
      passCategoryChoices: [
        {
          value: 0,
          text: 'Subscription Prime (Credit)',
        },
        {
          value: 1,
          text: 'Subscription (Time)',
        },
      ],
      passTypes: [
        {
          value: 1,
          text: '1 Day',
        },
        {
          value: 2,
          text: '2 Days',
        },
        {
          value: 3,
          text: '3 Days',
        },
        {
          value: 5,
          text: '5 Days',
        },
        {
          value: 7,
          text: '7 Days',
        },
        {
          value: 15,
          text: '15 Days',
        },
        {
          value: 30,
          text: '30 Days',
        },
        {
          value: 90,
          text: '90 Days',
        },
        {
          value: 180,
          text: '180 Days',
        },
        {
          value: 365,
          text: '365 Days',
        },
      ],

      vehicleTypes: [],
      unLockCharge: [
        {
          value: 0,
          text: 'No',
        },
        {
          value: 1,
          text: 'Yes',
        },
      ],
      reservationCharge: [
        {
          value: 0,
          text: 'No',
        },
        {
          value: 1,
          text: 'Yes',
        },
      ],
      statusOptions: [
        {
          value: false,
          text: 'Inactive',
        },
        {
          value: true,
          text: 'Active',
        },
      ],
      perCharges: [
        {
          value: 0,
          text: 'No',
        },
        {
          value: 1,
          text: 'Yes',
        },
      ],
      show_unlock_charge: true,
      show_reservation_charge: true,
      show_per_minute_charge: true,
      show_pause_per_unit_charge: true,
      show_free_minutes_each_ride: true,
      fleets: [],
      cardTitle: '',
      is_active: true,
      start_date: '',
      end_date: '',
      item: {},
      currencySymbol: '--',
    }
  },
  async created() {
    this.fleets = await getAllFleetsData()
    this.currencySymbol = this.$org.default_currency.symbol

    const orgVehicleTypes = this?.$org?.vehicle_type || []
    orgVehicleTypes.forEach((t) =>
      this.vehicleTypes.push(vehicleTypesForOrg[t])
    )
  },
  mounted() {
    EventBus.$on(PassConfig.events.editingData, (item) => {
      this.item = item
      this.form = {}

      if (Object.keys(this.item).length > 1) {
        //edit
        this.getPassDataByID(item.id)
      } else {
        //add
        this.init()
      }
    })
  },
  computed: {
    titleText() {
      return this.isEditing
        ? this.$t('components.subscriptionManagement.addEdit.headline.update')
        : this.$t('components.subscriptionManagement.addEdit.headline.add')
    },
    isEditing: function() {
      // enabled status-switch by default
      return Object.keys(this.item).length > 1
    },
    actionButtonText: function() {
      return this.isEditing
        ? this.$t('components.stepNavigation.update')
        : this.$t('components.stepNavigation.save')
    },
    getFleetOptions() {
      return this.fleets.map((fleet) => ({
        text: `${fleet.name} (${fleet.country.code3})`,
        value: fleet.id,
      }))
    },
    getPassStartDate() {
      return this.getDate(this.start_date)
    },
    getPassExpiredDate() {
      return this.getDate(this.end_date)
    },
  },
  watch: {
    'form.assigned_fleet': {
      immediate: true,
      deep: false,
      handler(val) {
        if (val) {
          const filteredData = this.fleets.find((item) => item.id === val)
          this.currencySymbol = filteredData.country.currency_symbol
        }
      },
    },
  },
  methods: {
    getDate,
    init() {
      this.form = {
        category: 0,
        period: 3,
        unlock_charge: 100,
        vehicle_type: 'A',
        profile_type: 'A',
        pass_type: 'DD',
        is_minimum_fee_waived: false,
        facility_texts: [],
      }
      this.start_date = ''
      this.end_date = ''
      this.show_unlock_charge = true
      this.show_reservation_charge = true
      this.show_per_minute_charge = true
      this.show_pause_per_unit_charge = true
      this.show_free_minutes_each_ride = true
    },
    onAddDescription() {
      this.form.facility_texts.push({ description: '' })
    },
    onRemoveDescription(index) {
      this.form.facility_texts.splice(index, 1)
    },
    submit() {
      this.$refs.submitButton.click()
    },
    showModal() {
      dispatchEvent(new Event(PassConfig.events.sorToggle))
    },

    onChangeStartDate(event) {
      this.start_date = event
      this.getValidateDays()
    },
    onChangeExpireDate(event) {
      this.end_date = event
      this.getValidateDays()
    },
    getValidateDays() {
      if (this.start_date != '' && this.end_date != '') {
        let date1 = new Date(this.start_date)
        let date2 = new Date(this.end_date)

        var Difference_In_Time = date2.getTime() - date1.getTime()
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24)
        if (Difference_In_Days >= 0) {
          this.validate_day = Difference_In_Days + ' days'
        } else {
          this.start_date = ''
          this.end_date = ''
        }
      }
    },
    getPassDataByID(id) {
      this.$http
        .get(PassConfig.api.detail(id))
        .then((res) => {
          var result = res.data
          this.form = {
            category: result.category,
            price: result.amount,
            per_minute_charge: result.per_minute_charge,
            pause_per_unit_charge: result.pause_per_unit_charge,
            reservation_charge: result.reservation_charge,
            unlock_charge: result.unlock_charge,
            period: result.period,
            profile_type: result.profile_type,
            vehicle_type: result.vehicle_type,
            free_minutes_each_ride: result.free_minutes_each_ride,
            free_riding_time_minutes: result.free_riding_time_minutes,
            assigned_fleet: result.assigned_fleet?.id ?? null,
            is_minimum_fee_waived: result.is_minimum_fee_waived ?? false,
            title: result.title,
            facility_texts: result.facility_texts.map((description) => {
              return { description }
            }),
          }
          this.is_active = result.is_active
          this.show_free_minutes_each_ride =
            result.free_minutes_each_ride &&
            result.free_minutes_each_ride != null
              ? true
              : false

          this.show_unlock_charge =
            result.unlock_charge && result.unlock_charge != null ? true : false
          this.show_reservation_charge =
            result.reservation_charge && result.reservation_charge != null
              ? true
              : false
          this.show_per_minute_charge =
            result.per_minute_charge != '' && result.per_minute_charge != null
              ? true
              : false
          this.show_pause_per_unit_charge =
            result.pause_per_unit_charge != '' &&
            result.pause_per_unit_charge != null
              ? true
              : false
          this.start_date = result.start_date
            ? result.start_date.split('/')[2] +
              '-' +
              result.start_date.split('/')[1] +
              '-' +
              result.start_date.split('/')[0]
            : ''
          this.end_date = result.end_date
            ? result.end_date.split('/')[2] +
              '-' +
              result.end_date.split('/')[1] +
              '-' +
              result.end_date.split('/')[0]
            : ''
        })
        .catch((err) => {
          console.log(err)
        })
    },

    async confirmSubmit() {
      const formProxy = {
        ...this.form,
        facility_texts: JSON.stringify(
          this.form.facility_texts
            .filter((item) => item.description && item.description.trim())
            .map((item) => item.description.trim())
        ),
      }
      const propertyNames = Object.keys(formProxy)
      propertyNames.map((name) => {
        if (formProxy[name] === null) {
          delete formProxy[name]
        }
      })
      formProxy.is_active = this.is_active
      if (this.state_date != '' && this.end_date != '') {
        formProxy.start_date =
          this.start_date.split('-')[2] +
          '/' +
          this.start_date.split('-')[1] +
          '/' +
          this.start_date.split('-')[0]
        formProxy.end_date =
          this.end_date.split('-')[2] +
          '/' +
          this.end_date.split('-')[1] +
          '/' +
          this.end_date.split('-')[0]
      } else {
        formProxy.start_date = ''
        formProxy.end_date = ''
      }

      if (!this.show_unlock_charge) {
        formProxy.unlock_charge = ''
      }

      if (!this.show_reservation_charge) {
        formProxy.reservation_charge = ''
      }

      if (!this.show_per_minute_charge) {
        formProxy.per_minute_charge = ''
      }
      if (!this.show_pause_per_unit_charge) {
        formProxy.pause_per_unit_charge = ''
      }

      if (!this.show_free_minutes_each_ride) {
        formProxy.free_minutes_each_ride = ''
      }

      if (formProxy.assigned_fleet == null) {
        delete formProxy.assigned_fleet
      }

      console.log('form = ', formProxy)

      let method = this.isEditing ? 'PATCH' : 'POST'
      let url = this.isEditing
        ? PassConfig.api.update(this.item.id)
        : PassConfig.api.create
      let data = new xMan(formProxy).toFormData()

      let message = this.isEditing
        ? 'Pass updated successfully'
        : 'Pass added successfully'

      this.isLoading = true
      try {
        let response = await this.$http({
          method,
          url,
          data,
        })

        console.log('response = ', url, '  ', method, '  ')
        console.log('data = ', response)

        this.isLoading = false
        // Close the slideover
        dispatchEvent(new Event(PassConfig.events.sorToggle))
        dispatchEvent(new Event(PassConfig.events.refresh))
        this.$emit('add-edit')
        // Reset the form
        this.form = {}
        this.$notify({
          group: 'bottomLeft',
          type: 'success',
          title: 'Success',
          text: message,
        })
        // Resolved
        return response.status
      } catch (error) {
        const e = error.response
        console.log('err', e)

        this.$notify(
          {
            group: 'bottomLeft',
            type: 'error',
            title: `${convertToTitleCase(e.data.code)}`,
            text: e.data.message ?? 'The action could not be executed',
          },
          5000
        )

        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.header-title {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2e2e39;
}
.header-status {
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2e2e39;
  margin-right: 10px;
}
.toggle-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2e2e39;
}
.promo-type-card {
  width: 100%;
  height: 200px;
  background: white;
  border-radius: 22px;
  border: 3px dashed #ee9200;
  margin-top: 20px;
  position: relative;
  .promo-right-icon {
    width: 200px;
    height: 55px;
    background: #ee9200;
    position: absolute;
    right: -3px;
    top: -3px;
    border-top-right-radius: 22px;
    border-bottom-left-radius: 60px;
    display: flex;
    span {
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #ffffff;
      font-family: Roboto;
    }
  }
  .promo-card-body {
    h3 {
      font-family: Roboto;
      font-size: 37px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #0d0d0d;
    }
    span {
      font-size: 19px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #ee9200;
      margin-top: 5px;
    }
  }
}
.multi-selecter {
  span {
    width: 100%;
  }
}
.multiselect__tags {
  border-color: #cbd5e0 !important;
}
</style>
